var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useContext, useRef } from 'react';
import { StateConfigContext } from '../../../../providers';
import { config, getCarouselButtonProps, getCarouselButtonStyles } from './CarouselButtonStyles';
import { Pressable, View } from 'react-native';
import { DynamicSvg } from '../../../dynamic-svg';
import { getTestId } from '../../../../utils';
export var CarouselButton = props => {
  var _a, _b, _c, _d;
  var stateContext = useContext(StateConfigContext);
  var carouselButtonProps = getCarouselButtonProps(props, stateContext);
  var testID = carouselButtonProps.testID,
    onPress = carouselButtonProps.onPress,
    disabled = carouselButtonProps.disabled,
    style = carouselButtonProps.style,
    size = carouselButtonProps.size,
    iconName = carouselButtonProps.iconName,
    controlState = carouselButtonProps.controlState,
    restProps = __rest(carouselButtonProps, ["testID", "onPress", "disabled", "style", "size", "iconName", "controlState"]);
  var stylesBasedOnState = useRef({});
  var iconColor = (_b = (_a = config === null || config === void 0 ? void 0 : config.controlState) === null || _a === void 0 ? void 0 : _a[controlState]) === null || _b === void 0 ? void 0 : _b.iconColor;
  var iconSize = (_d = (_c = config === null || config === void 0 ? void 0 : config.size) === null || _c === void 0 ? void 0 : _c[size]) === null || _d === void 0 ? void 0 : _d.iconSize;
  var getPressableStyle = useCallback(event => {
    var styles = getCarouselButtonStyles(carouselButtonProps, event);
    stylesBasedOnState.current = styles;
    return [styles.container, style];
  }, [carouselButtonProps]);
  return _jsx(Pressable, Object.assign({
    style: getPressableStyle,
    disabled: disabled,
    onPress: onPress
  }, restProps, {
    children: () => {
      var _a;
      return _jsx(View, Object.assign({
        style: (_a = stylesBasedOnState === null || stylesBasedOnState === void 0 ? void 0 : stylesBasedOnState.current) === null || _a === void 0 ? void 0 : _a.innerContainerStyle
      }, {
        children: !!iconName && _jsx(DynamicSvg, Object.assign({
          iconName: iconName,
          color: iconColor,
          fontSize: iconSize
        }, getTestId(testID, 'icon')))
      }));
    }
  }));
};